import { pad, renderDate, renderMoney, dateRangeFilter } from '../../../common/services/util';
import React from 'react';
import DateRangeFilter from 'common/components/DateRangeFilter';

export const getColumns = (renderCount, checkedSelected, checkAll) => {
    const textArea = props => <textarea
        type="text"
        style={{width: '100%', fontFamily: 'Roboto, Helvetica, Arial, sans-serif'}}
        rows='3'
        value={props.value}
        onChange={e => props.onChange(e.target.value)}
    />

    const columns = [
        { 
            title: '', 
            field: 'selected', 
            render: props => checkedSelected(props),
            editable: 'never', 
            cellStyle: { width: '30px'},
            filterComponent: () => checkAll()
        },
        { title: 'Referencia', field: 'reference', editable: 'never', defaultSort: 'desc' },
        { title: 'Descripcion', field: 'description', editComponent: textArea, cellStyle: { width: '300px' } },
        { title: 'Marca', field: 'brand', searchable: false },
        { title: 'Modelo', field: 'model', editComponent: textArea, cellStyle: { width: '300px'}, searchable: false },
        { title: 'NºSerie', field: 'number', editComponent: textArea, cellStyle: { width: '500px'} }, 
        { title: 'Color', field: 'color'},
        { title: 'Cantidad', field: 'count', render: renderCount, type: 'numeric' },
        { title: 'Calidad', field: 'quality' },
        { title: 'Categoria', field: 'category' },
        { title: 'Ult. Modificacion', field: 'lastUpdated', type: 'date', editable: 'never',
            filterComponent: props => <DateRangeFilter {...props} />,
            customFilterAndSearch: (filter, rowData) => dateRangeFilter(filter, rowData.lastUpdated),
            render: rowData => rowData ? renderDate(rowData.lastUpdated) : ""
        },
        { title: 'Localizacion', field: 'location' },
        { title: 'PC', field: 'pc', type: 'numeric', render: rowData => renderMoney(rowData.pc) },
        { title: 'PVP', field: 'pvp', type: 'numeric', render: rowData => renderMoney(rowData.pvp) },
        { title: 'PVM', field: 'pvm', type: 'numeric', render: rowData => renderMoney(rowData.pvm) },
        { title: 'OBS', field: 'obs', editComponent: textArea, cellStyle: { width: '300px' } },
        { title: 'Search', field: 'search', hidden: true, searchable: true }
    ]

    return columns 
}

export const applyDefaultCreated = (stock, reference) => {
    stock.lastUpdated = new Date().getTime();
    stock.reference = pad(reference, 4);
    stock.count = stock.count || 0
}